export { default, default as Modal } from './Modal'
export * as ModalStyles from './styles/Modal.style'

export type { ModalProps } from './Modal.types'
export type { StyledModalProps } from './styles/Modal.style.types'
